import { WatchList } from '../partials/WatchList';
import classes from './WatchlistPage.module.scss';
export const WatchlistPage = () => {
  return (
    <div className={classes.nbWatchlistPage}>
      <WatchList isWidgetMode={false} />
    </div>
  );
};
